import { Card, Typography, Box } from '@material-ui/core'

import React from 'react'

import { EmptyContent } from '../../../clients/file/components/shared/emptyCard'

import ButtonWithPermissions from '../../../../components/buttonWithPermissions/buttonWithPermissions'
import { useTranslation } from 'react-i18next'

type AttachedFilesEmptyCardProps = {
  buttonDisabled: boolean
  onClick: () => void
}

export const AttachedFilesEmptyCard: React.FC<AttachedFilesEmptyCardProps> = ({
  buttonDisabled,
  onClick
}) => {
  const [t] = useTranslation(['procedures', 'globalerisLibrary', 'enums'])

  const title = buttonDisabled
    ? t('procedures:components.attachedFilesTable.emptyCard.selectContract')
    : t('procedures:components.attachedFilesTable.emptyCard.title')

  return (
    <Card raised style={{ marginTop: 16 }}>
      <EmptyContent title={title}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <ButtonWithPermissions
            hasPermission={true}
            size="small"
            color="primary"
            variant="contained"
            onClick={onClick}
            disabled={buttonDisabled}
          >
            {t('procedures:components.attachedFilesTable.emptyCard.buttonLabel')}
          </ButtonWithPermissions>
        </Box>
      </EmptyContent>
    </Card>
  )
}
